/**
 * Helper for main-navigation.
 * Handles mousedown and focus elements to replace the click-event.
 * If the item is the same like the compared element the modifier will be removed.
 * If mouse-event is mouse-down, it will toggle the modifier.
 * On focus the modifier will be added. If no element exist to compare, it will just
 * remove the modiefier from element.
 * @param {String} type - event type
 * @param {Element} item
 * @param {Element} compareItem
 * @param {String} modifier
 * @param {Boolean} isDesktop
 */
export default function mouseDownFocusHandler(type, item, compareItem, modifier, isDesktop) {
  if (compareItem) {
    if (compareItem !== item) {
      item.classList.remove(modifier);
    } else {
      switch (type) {
        case 'mousedown':
          if (isDesktop) {
            item.classList.toggle(modifier);
          } else {
            item.classList.add(modifier);
          }
          break;
        case 'focus':
          item.classList.add(modifier);
          break;
        default:
          item.classList.remove(modifier);
          break;
      }
    }
  } else {
    item.classList.remove(modifier);
  }
}
